import React from 'react';
import { HeroUIProvider } from '@heroui/react';
import { useTheme } from '../themes';

export const ThemeAwareHeroUIProvider = ({ children }) => {
  const { currentMode } = useTheme();

  return (
    <HeroUIProvider theme={currentMode}>
      {children}
    </HeroUIProvider>
  );
};
